var currentFilterCookie;
var lastScrollPosBeforeZoom = 0;
var lastScrollTop = 0;
var lastWidth, lastHeight;
var callNewsletterDone = false;
var loopBackgroundBloc4, aBackgroundBloc4;
var sliderHomepage;
var userLangSmall = '';
var currentScrollTop = 0;
var currentFilterActive = currentFilter = 'all';

$(document).ready(function(){
	var disableAutoTranslation = readCookie('rsvp-disable-auto-translation');
  	var disableRedirection = readCookie('rsvp-disable-redirection');
    var userLang = navigator.language || navigator.userLanguage;
  	userLang = String(userLang).toLowerCase();
  	
  	if (disableRedirection != 1 && userLang != '') {
      	userLangSmall = userLang.split("-")[0];
      	/*if (userLangSmall == 'ko') {
          	if (String(window.location.href).indexOf('from=rsvp-paris.kr') != -1) createCookie("rsvp-disable-redirection", 1, (1/24));
            else window.location.href = "https://rsvp-paris.kr/";
      	} else if (userLangSmall == 'ja') {
          	if (String(window.location.href).indexOf('from=jp.rsvp-paris.com') != -1) createCookie("rsvp-disable-redirection", 1, (1/24));
            else window.location.href = "https://jp.rsvp-paris.com/";
      	} else if (userLangSmall == 'zh') {
          	if (userLang == 'zh-cn') {
                if (String(window.location.href).indexOf('from=cn.rsvp-paris.com') != -1) createCookie("rsvp-disable-redirection", 1, (1/24));
                else window.location.href = "https://cn.rsvp-paris.com/";
            } else if (userLang == 'zh-tw' || userLang == 'zh-cht') {
                if (String(window.location.href).indexOf('from=tw.rsvp-paris.com') != -1) createCookie("rsvp-disable-redirection", 1, (1/24));
                else window.location.href = "https://tw.rsvp-paris.com/";
            } else {
              if (disableAutoTranslation != 1) {
                createCookie("rsvp-disable-auto-translation", 1, (1/24));
              }
            }
      	}*/
	}
  
  	if ($.browser.mobile) $('body').addClass('mobile');
  	else $('body').addClass('no-mobile');
  
  	if (isTouchDevice()) $('body').addClass('touch');
  	else $('body').addClass('no-touch');

    // Collection Layout
    //var currentLayoutType = readCookie('current-layout-type');
    //if (!currentLayoutType) currentLayoutType = 'classic';

    $('.layout a.layout-toggle').click(function(e){
      e.preventDefault();
      var type = $(this).data('type');
      //createCookie('current-layout-type', type, 365);
      $('.layout a.layout-toggle').removeClass('active');
      $(this).addClass('active');
      $('.main-content').removeClass('type-classic type-large').addClass('type-' + type);

      if (currentFilter == 'all') {
        if (type == 'large') {
          $('.collection-list .product-grid .products-section.insert-mode6').show();
          $('.collection-list .product-grid .products-section.insert-mode4').hide();
        } else {
          $('.collection-list .product-grid .products-section.insert-mode4').show();
          $('.collection-list .product-grid .products-section.insert-mode6').hide();
        }
      } else {
        $('.collection-list .product-grid .products-section.insert').hide();
      }

      window.dispatchEvent(new Event('resize'));
    });
    //$('.layout a[data-type="' + currentLayoutType + '"]').click();
  
  	// Special Card FR
    if (userLangSmall == 'fr') $('.text-3x-fr').show();
  
  	// Newsletter 
  	$('.form-klaviyo form .lang a').click(function(e){
      e.preventDefault();
      $(this).closest('form').find('.lang a').removeClass('on');
      $(this).addClass('on');
      $(this).closest('form').find('input.lang').val($(this).data('lang'));
  	});
  	$('footer .foot-menu a[href^="#open-newsletter-v2-popin"], .open-newsletter-v2-popin').click(function(e){
      e.preventDefault();
      $('body').addClass('js-newsletter-v2-in');
      Resize();
    });
  	$('#newsletter-v2-popin .layer, #newsletter-v2-popin .button-close').click(function(e){
      e.preventDefault();
      $('body').removeClass('js-newsletter-v2-in');
    });

	// Custom scroll
  	$(".menu-v2 .scroll .inner, .offscreen-menu .scroll .inner").mCustomScrollbar({
		axis: "x",
		theme: "dark-thin",
		scrollInertia: 100,
		mouseWheel: {
			preventDefault: true
		}
	});

  	$("body.no-mobile .offscreen-menu .pad-content").mCustomScrollbar({
		axis: "y",
		theme: "dark-thin",
		scrollInertia: 100,
		mouseWheel: {
			preventDefault: true
		}
	});

  /*$('.sub li a[data-value="fr"]').attr('href', "https://rsvp-paris.com" +window.location.pathname+'?from=en.rsvp-paris.com');
  $('.sub li a[data-value="en"]').attr('href', "https://en.rsvp-paris.com" +window.location.pathname);
  $('.sub li a[data-value="ko"]').attr('href', "https://kr.rsvp-paris.com" +window.location.pathname);
  $('.sub li a[data-value="cn"]').attr('href', "https://cn.rsvp-paris.com" +window.location.pathname);
  $('.sub li a[data-value="tw"]').attr('href', "https://tw.rsvp-paris.com" +window.location.pathname);*/

  	// Submenu touch
  if (isTouchDevice()) {
    $('.menu-v2 .open-scroll-submenu > a').click(function(e){
      e.preventDefault();
      $('.menu-v2 .open-scroll-submenu.open').removeClass('open');
      $(this).parent().addClass('open');
    });
    $('.wrapper').click(function(){
      $('.menu-v2 .open-scroll-submenu.open').removeClass('open');
    });
  }

  	// Submenu mobile
	$(".offscreen-menu .open-scroll-submenu > a").bind('click', function(e){
		e.preventDefault();

      	$(this).parent().find('.scroll').click();

      	if ($(this).parent().is(".open")) {
        	$(this).parent().removeClass('open');
        } else {
          	$(".offscreen-menu .open").find('.sub').slideUp(150);
          	$(".offscreen-menu .open").removeClass('open');

	        $(this).parent().addClass('open');
        }
	});

	$(".offscreen-menu .open-text-submenu > a").bind('click', function(e){
		e.preventDefault();

      	if ($(this).parent().is(".open")) {
        	$(this).parent().removeClass('open');
	        $(this).parent().find('.sub').slideUp(150);
        } else {
            $(".offscreen-menu .open").find('.sub').slideUp(150);
          	$(".offscreen-menu .open").removeClass('open');

	        $(this).parent().addClass('open');
            $(this).parent().find('.sub').slideDown(150);
        }
	});

	/*$('.offscreen-menu .open-scroll-submenu .scroll a').on('click', function(e) {
		e.preventDefault();
		window.location = $(this).attr('href');
	});*/

  	// Submenu desktop
  	var toMenuScroll;
  	$(".menu-v2 .open-scroll-submenu").mouseenter(function(){
      	$(".menu-v2 .direct").removeClass('direct');
        if ($(".menu-v2 .open").length > 0)
              $(this).addClass('direct');
      	if (!$(this).is(".open"))
        	closeMenuScroll();

      	clearTimeout(toMenuScroll);
      	$(this).addClass('open');
	}).mouseleave(function(){
	    toMenuScroll = setTimeout(closeMenuScroll, 150);
	});
    function closeMenuScroll() {
      $(".menu-v2 .open .scroll").fadeOut(150, function(){
        $(this).parent().removeClass('open');
      });
    }


    /*setTimeout(function() {
      $('.lang-label').text(Weglot.getCurrentLang());
    }, 10);*/
  
   	// Submenu currencies / lang
    /*$('.menu-v2 ul li.currencies .sub a').click(function(e){
        e.preventDefault();
        var newCurrency = $(this).data('value');
        Currency.convertAll(Currency.currentCurrency, newCurrency);
        var currencyText = $('.menu-v2 ul li.currencies .sub a[data-value="'+Currency.currentCurrency+'"]').data("label");
	  	$('.currency-label').text(currencyText);
        if (newCurrency != shopCurrency) roundCurrency();
      	$(".menu-v2 ul li.dropdown.open").removeClass("open");
    });*/
    $('.menu-v2 ul li.currencies .sub a').click(function(e){
        e.preventDefault();
        var f = $(this).closest('li.currencies').find('form');
      	f.find('select option[value="' + $(this).data('value') + '"]').attr('selected', 'selected');
        f.submit();
    });
  	
  	$('.menu-v2 ul li.lang .sub a').click(function(e){
        e.preventDefault();
      	window.location.href = $(this).attr("href");
    });

  	// Dropdown
	$(".menu-v2 ul li.dropdown:not(.lang) a").click(function(e){
      	e.preventDefault();
      	var elem = $(this).parent();
	    $(".menu-v2 ul li.dropdown.open").not(elem).toggleClass('open');
      	elem.toggleClass('open');
	});
  	$(".menu-v2 ul li.dropdown").mouseleave(function(e){
      	e.preventDefault();
      	if ($(this).is(".open")) $(this).removeClass("open");
        if ($(this).find('.nice-select').is(".open")) $(this).find('.nice-select').removeClass("open");
	});

	// Cookies
  	var savedLang = readCookie('ljs-lang'), savedCurrency = readCookie('acscurrency');
	// if (savedLang && savedLang != 'ko' && savedLang != langParameters) $('.menu-v2 ul li.lang .sub a[data-value="'+savedLang+'"]').click();
	if (savedCurrency) $('.currency-label').text($('.menu-v2 ul li.currencies .sub a[data-value="'+savedCurrency+'"]').data('label '));
  
  	// Product V2
  	if ($(".product-colors-mobile").length > 0) {
      	$(".product-colors-mobile .inner").html($(".product-colors").html());
      	//$(".product-colors-mobile").flickity({contain:true,pageDots:false,groupCells:true,selectedAttraction:.08,friction:.6});
  	}
	$(".product-v2 .col-right.product-infos-col").mouseup(function(){
		ResizeProductColRight();
      	setTimeout(function(){ ResizeProductColRight(); }, 100);
    });
  	$(".zoom-thumb a").click(function(e){
      	e.preventDefault();
      	ZoomScrollTo($(this).data("index"), 250);
  	});
  	
  	if ($.browser.mobile) {
      $(".product-item .product-item-link").bind("touchstart", function(){
        $(this).find("#hover-jauge").removeClass("hidden");
      }).bind("touchend", function(){
        $(this).find("#hover-jauge").addClass("hidden");
      });
    }
  
  	if ($('.product-colors *').length <= 0) $('.product-colors, .product-colors-mobile').addClass('empty hidden');
  
  	// Ratio
	$(".js-ratio").each(function(i){
		var r = String($(this).attr("data-ratio")).split(":");
		$(this).attr("data-ratio", (r[1]/r[0]));

		if ($(this).attr("data-ratio-mobile")) {
			r = String($(this).attr("data-ratio-mobile")).split(":");
			$(this).attr("data-ratio-mobile", (r[1]/r[0]));
		} else {
			$(this).attr("data-ratio-mobile", $(this).attr("data-ratio"));
		}
	});
  	
	// Slider
    var optionsSliderHomepage = {adaptiveHeight:true,wrapAround:true,autoPlay:5000,touchVerticalScroll:"withDrag",accessibility:false,draggable:false,lazyLoad:1,imagesLoaded:true,
	  on: {
        ready: function() {
          $(".home-2020 .slider .gallery-cell video:visible").each(function(){
            $(this).unbind("canplay canplaythrough").removeClass("playing");
            $(this)[0].pause();
          });
          
          $(".home-2020 .slider .gallery-cell.is-selected video:visible").each(function(){
            if ($(this)[0].readyState >= 3 || $(this)[0].readyState == 1) {
              $(this)[0].play();
              $(this).addClass("playing");
              if (sliderHomepage) sliderHomepage.flickity('resize');
            }

            $(this).on("canplay canplaythrough", function(){
                if (!$(this).is(".playing")) {
                    $(this)[0].play();
                    $(this).addClass("playing");
                  	if (sliderHomepage) sliderHomepage.flickity('resize');
                }
            });
            
            if (!$(this).is(".playing")) $(this)[0].load();
          });
      	},
        change: function(index) {
          $(".home-2020 .slider .gallery-cell video:visible").each(function(){
            $(this).unbind("canplay canplaythrough").removeClass("playing");
            $(this)[0].pause();
          });
          
          $(".home-2020 .slider .gallery-cell.is-selected video:visible").each(function(){
            if ($(this)[0].readyState >= 3 || $(this)[0].readyState == 1) {
              $(this)[0].play();
              $(this).addClass("playing");
              if (sliderHomepage) sliderHomepage.flickity('resize');
            }

            $(this).on("canplay canplaythrough", function(){
                if (!$(this).is(".playing")) {
                    $(this)[0].play();
                    $(this).addClass("playing");
                  	if (sliderHomepage) sliderHomepage.flickity('resize');
                }
            });
            
            if (!$(this).is(".playing")) $(this)[0].play();
          });
      	}
	  }
	};
    sliderHomepage = $(".home-2020 .slider").flickity(optionsSliderHomepage);
  
  	var optionsSliderInstagram = {groupCells:true,contain:true,imagesLoaded:true,pageDots:true,prevNextButtons:false,selectedAttraction:.08,friction:.6,lazyLoad:1};
	$(".products-insta .slider-insta").flickity(optionsSliderInstagram);
	if (matchMedia('screen and (min-width: 768px)').matches) optionsSliderInstagram.groupCells = false;
  
	var optionsSliderRelatedProducts = {groupCells:true,contain:true,imagesLoaded:true,pageDots:true,prevNextButtons:true,selectedAttraction:.08,friction:.6,lazyLoad:1,on:{settle:function(index){ $(".products-related-scrolling .slider-related-products .lazy").trigger("scroll"); }}};
	$(".products-related-scrolling .slider-related-products").flickity(optionsSliderRelatedProducts);
  
  	var optionsSliderBloc4 = {groupCells:true,contain:true,imagesLoaded:true,pageDots:true,prevNextButtons:false,selectedAttraction:.08,friction:.6,lazyLoad:1};
	$(".home-2020 .slider-bloc4").flickity(optionsSliderBloc4);
	if (matchMedia('screen and (min-width: 768px)').matches) optionsSliderBloc4.groupCells = false;
  	
  	// Home BG anim
  	/*if ($('.home-2020 .blocs.n4').length) {
      loopBackgroundBloc4 = 0;
      aBackgroundBloc4 = ['#ff7c67', '#fffb93', '#7ce9a2', '#93d2e4', '#93dcff', '#f7b5c0'];
      setInterval(function(){
        loopBackgroundBloc4++;
        if (loopBackgroundBloc4 == aBackgroundBloc4.length) loopBackgroundBloc4 = 0;
        $('.home-2020 .blocs.n4').css({'background-color': aBackgroundBloc4[loopBackgroundBloc4]});
      }, 2500);
	}*/
  
    // STOCKIST SLIDER
  var optionsSliderStockist = {adaptiveHeight:true,groupCells:false,contain:true,imagesLoaded:true,pageDots:true,prevNextButtons:true,selectedAttraction:.08,friction:.6,lazyLoad:1};
	$(".stockist-slider").flickity(optionsSliderStockist);
  
    // SECOND HAND
    if ($(".top-second-hand .bg").length && $(".top-second-hand .bg").is(':visible'))
    {
      var bg_elem = $(".top-second-hand .bg");
      setInterval(function(){
        var big_move_x = Math.floor((Math.random() * 4) + 1);
        var big_move_y = Math.floor((Math.random() * 4) + 1);
        
        var x = Math.floor(Math.random() * (big_move_x > 1 ? 2 : 12));
        var y = Math.floor(Math.random() * (big_move_y > 1 ? 2 : 12));
        
        bg_elem.css({
          '-webkit-transform' : 'translate3d('+x+'px, '+y+'px, 0)',
          'transform' : 'translate3d('+x+'px, '+y+'px, 0)'
        });
      }, 75);
    }

  // MENU 2023
  var toSubmenu2023Close;
  
  $('.menu-2023 li.n1').mouseenter(function(){
    var submenu = $(this).data('menu');
    
    if (submenu && submenu != '') {
      $('.menu-2023-hover .submenu').removeClass('open');
      
      $('.menu-2023-hover, .menu-2023-overlay').addClass('open');
      $('.menu-2023-hover .submenu[data-menu="' + submenu + '"]').addClass('open');

      $(".menu-2023-hover .slider").flickity('resize');
    } else {
      closeSubmenu2023();
    }
  });

  /*$('.menu-2023 li.n1 > a, .menu-2023-hover li.n2 > a, .menu-2023-hover li.n3 > a').mouseenter(function(){
    var poster = $(this).data('poster');
    if (poster && poster != '') $('.menu-2023-hover .bg-cover').css({'background-image': 'url('+poster+')'});
  });*/
  
  $('.menu-2023-hover').mouseleave(function(){
    closeSubmenu2023();
  });

  $('.offscreen-menu .menu.menu-2023 li.n1.plus > a').click(function(e){
    e.preventDefault();
    $(this).parent().toggleClass('open');
    $(".offscreen-menu .menu.menu-2023 .slider").flickity('resize');
  });
  
  function closeSubmenu2023() {
    $('.menu-2023-hover, .menu-2023-hover .submenu, .menu-2023-overlay').removeClass('open');
  }

  var optionsSliderMenu2023 = {groupCells:true,contain:true,imagesLoaded:true,pageDots:false,prevNextButtons:true,selectedAttraction:.08,friction:.6,lazyLoad:0};
  $(".menu-2023-hover .slider, .offscreen-menu .menu.menu-2023 .slider").flickity(optionsSliderMenu2023);

  $('.search .btn-open-search').click(function(e){
    e.preventDefault();
    $('#search-bar').toggleClass('open');
    $('#search-bar input').focus();
  });
  $('#search-bar .close').click(function(e){
    e.preventDefault();
    $('#search-bar').removeClass('open');
  });

  // COOKIE
  testCookieCookie = readCookie('rsvp-cookie-view');
  if (testCookieCookie == undefined) {
    $('body').addClass('js-cookie-v2-in');
    
    $('#cookie-v2-popin').click(function(e){
      e.preventDefault();
      $('body').removeClass('js-cookie-v2-in');
      createCookie('rsvp-cookie-view', 1, 30); // 1 month
    });
  }

    // BACK IN STOCK CUSTOM
    $('a.bis-custom').click(function(e){
      e.preventDefault();
      $('#bis-layer').addClass('open');
    });
    $('#bis-layer .close').click(function(e){
      e.preventDefault();
      $('#bis-layer').removeClass('open done fail');
    });

    // GEOLOC
    $('#geoloc-popup-locale').change(function(){
      var locale = $('#geoloc-popup-locale option:selected').val();

      if (locale == 'cn') {
        $('#geoloc-popup-country').addClass('disabled');
      } else {
        $('#geoloc-popup-country').removeClass('disabled');
      }
    });
  
    $('#geoloc-popup a.confirm').click(function(e){
      e.preventDefault();

      var country = $('#geoloc-popup-country option:selected').val();
      var locale = $('#geoloc-popup-locale option:selected').val();
      
      $('#geoloc-popup input[name="country_code"]').attr('value', country);
      $('#geoloc-popup input[name="language_code"]').attr('value', locale);

      /*if (locale == 'kr') window.location.href = "https://rsvp-paris.com/ko-kr";
      else if (locale == 'jp') window.location.href = "https://jp.rsvp-paris.com/";*/
      
      if (locale == 'cn') window.location.href = "/pages/rsvp-wechat-store";
      else {
        //if (locale == 'fr') $('#geoloc-popup input[name="country_code"]').attr('value', 'FR');
        $('#geoloc-popup form').submit();
      }
    });
  
    $('#geoloc-popup .under').click(function(e){
      e.preventDefault();
      $('#geoloc-popup a.close').click();
    });
  
    $('#geoloc-popup a.close').click(function(e){
      e.preventDefault();
      $('body').removeClass('geoloc-popup-open');
    });
  
    $('.geoloc-popup-bt-open').click(function(e){
      e.preventDefault();
      $('body').addClass('geoloc-popup-open');
    });
    $('.menu-v2 ul li.dropdown.lang a').click(function(e){
        e.preventDefault();
      	$('.geoloc-popup-bt-open').click();
    });

    // ...
    $('.product-medias-col .thumbs .gallery-cell').click(function(e){
      e.preventDefault();
      var pos = $('.product-medias-col .product-medias .gallery-cell[data-index="' + $(this).data('index') + '"]').position();
      $('html, body').animate({scrollTop: (pos.top + 40)}, 250);
    });

    $('.product-color-open').click(function(e){
      e.preventDefault();
      if (!$(this).is('.off')) {
        $('.product-colors-container').toggleClass('open');
        var nbLine = Math.ceil($('.product-colors-container .product-colors .link').length / 5);
        var h = $('.product-colors-container .product-colors .link:eq(0)').height();
        if ($('.product-colors-container').is('.open')) {
          $('.product-colors-container .product-colors').animate({'height': (nbLine * h)}, 250);
          createCookie('rsvp-color-swatches-open', 1, 30);
        } else {
          $('.product-colors-container .product-colors').animate({'height':h}, 250);
          createCookie('rsvp-color-swatches-open', 0, 30);
        }
      }
    });

    $('.product-color-open-mobile').click(function(e){
      e.preventDefault();
      $('html, body').addClass('block-perso');
      $('.nav-left, .nav-right').addClass('hide');
      $('.shopify-section, footer').addClass('disabled-div');
      $('.product-colors-mobile').addClass('open');
    });
    $('.product-colors-mobile .close').click(function(e){
      e.preventDefault();
      $('html, body').removeClass('block-perso');
      $('.nav-left, .nav-right').removeClass('hide');
      $('.shopify-section, footer').removeClass('disabled-div');
      $('.product-colors-mobile').removeClass('open');
    });

    testColorSwatchesOpen = readCookie('rsvp-color-swatches-open');
    if (testColorSwatchesOpen == 1) {
      $('.product-colors-container').addClass('open');
      var nbLine = Math.ceil($('.product-colors-container .product-colors .link').length / 5);
      var h = $('.product-colors-container .product-colors .link:eq(0)').height();
      $('.product-colors-container .product-colors').css({'height': (nbLine * h)});
    } else {
      var h = $('.product-colors-container .product-colors .link:eq(0)').height();
      $('.product-colors-container .product-colors').css({'height': h});
    }

    // BTN FILTERS
    var itemsSortStart = new Array();
    $('.collection-list .product-grid').each(function(i){
      itemsSortStart[i] = $(this).find('.products-section');
    });
    $('.filters .page-size').text($('.collection-list .products-section:not(.insert)').length);

    $('.btn-filters').click(function(e){
      e.preventDefault();

      filter = currentFilter = $(this).data("filter");
      currentFilterActive = $('.btn-filters.active').data("filter");
      $('.filters .page-size').text($('.collection-list .products-section:not(.insert)').length);

      // SORT
      var itemsSort;
      $('.collection-list .product-grid').each(function(i){
        itemsSort = $(this).find('.products-section');

        if (filter == 'all') {
          itemsSort = itemsSortStart[i];
        } else if (filter == 'preorder') {
          itemsSort.sort(function(a, b) { return $(a).attr('data-date').localeCompare($(b).attr('data-date')); });
        } else {
          itemsSort.sort(function(a, b) { return parseInt($(a).attr('data-sort')) - parseInt($(b).attr('data-sort')); });
        }

        $(this).find('.products-section').remove();
        $(this).empty().append(itemsSort);
        $(this).find('img.lazy').lazyload({threshold: 500});
      });

      // FILTER
      if (filter != currentFilterActive) {
        if (filter == 'all') {
          $('.collection-list .product-grid .products-section').show();
          if ($('.main-content').is('.type-large')) $('.collection-list .product-grid .products-section.insert-mode4').hide();
          else $('.collection-list .product-grid .products-section.insert-mode6').hide();
        } else {
          $('.collection-list .product-grid .products-section').hide();
          $('.collection-list .product-grid .products-section:not(.insert)[data-type="' + filter + '"]').show();
          $('.filters .page-size').text($('.collection-list .product-grid .products-section:not(.insert)[data-type="' + filter + '"]').length);
        }
        $('.btn-filters').removeClass('active');
        $(this).addClass('active');
      } else {
        if (filter != 'all') {
          filter = 'all';
          $('.collection-list .product-grid .products-section').show();
          if ($('.main-content').is('.type-large')) $('.collection-list .product-grid .products-section.insert-mode4').hide();
          else $('.collection-list .product-grid .products-section.insert-mode6').hide();
          $('.btn-filters').removeClass('active');
          $('.btn-filters[data-filter="all"]').addClass('active');
        }
      }

      // SAVE
      currentFilterCookie = filter;
      createCookie('rsvp-filter-cookie', currentFilterCookie, 365);
    });
  
    currentFilterCookie = readCookie('rsvp-filter-cookie');
    currentFilterCookie = 'all';
    if (currentFilterCookie == undefined) {
      createCookie('rsvp-filter-cookie', 'all', 365);
      currentFilterCookie = 'all';
    } else if (currentFilterCookie != 'all') {
      if ($('.collection-list .product-grid .products-section[data-type="' + currentFilterCookie + '"]').length <= 0) {
        createCookie('rsvp-filter-cookie', 'all', 365);
        currentFilterCookie = 'all';
      } else {
        $('.btn-filters[data-filter="' + currentFilterCookie + '"]').click();
      }
    }

    // RUN  	
    InitScroll();
  	InitResize();
  	InitKey();
});

$(window).load(function() {
  // Hands
  $('.home-2020 .hand').each(function(i){
    var posY = $(this).offset().top - ($(window).height() / 2);
    $(this).data("start-pos", posY);
  });
});

function InitKey() {
  $(document).keydown(function(e) {
    if (e.keyCode == 27) {
      if ($("body").is(".js-media-zoom-in")) $('.js-media-zoom .gallery-cell:eq(0)').click();
      if ($("body").is(".js-newsletter-v2-in")) $('body').removeClass('js-newsletter-v2-in');
      if ($(".call-perso-modal").is(":visible")) $('.call-perso-modal .close').click();
    }
  });
}

function InitResize() {
  $(window).resize(function(){ Resize(); });
	document.addEventListener("webkitfullscreenchange",function(){ Resize(); }, false);
	window.onorientationchange = function(){ var orientation = window.orientation; Resize(); }
	Resize();
	setTimeout(function(){ Resize(); }, 500);
}
function Resize() {
  lastWidth = $(window).width();
  lastHeight = $(window).height();
  if ($(".product-v2 .product-infos-col .product-infos").length > 0) ResizeProductColRight();
  
  // Ratio
  $(".js-ratio").each(function(i){
    if (lastWidth < 768) $(this).height(Math.ceil($(this).outerWidth() * $(this).attr("data-ratio-mobile")));
    else $(this).height(Math.ceil($(this).outerWidth() * $(this).attr("data-ratio")));
  });
  
  // Cookie
  if (lastWidth < 1100) {
    var hCookie = 0;
    if ($('body').is(".cookie-open")) hCookie = $('.alert-cookie').outerHeight();
    
    $('.menu-v2, .offscreen-menu, .offscreen-menu .menu, .offscreen-newsletter, .offscreen-newsletter .overlay, .offscreen-newsletter .newsletter, .offscreen-cart, .offscreen-cart .overlay, .offscreen-cart .cart').css({'top':hCookie});
    $('.js-menu-in .menu-v2').attr('style', 'top: '+(hCookie)+'px !important');
    $('.menu-v2-burger').css({'top':(hCookie+9)});
    $('body.js-menu-in .menu-v2-burger').attr('style', 'top: '+(hCookie+9)+'px !important');
    $('.fixed-elements').css({'top':(hCookie+56)});
    if (hCookie > 55) $('.main-content-fluid, .main-content').css({'margin-top':((hCookie-55)+56)});
    else $('.main-content-fluid, .main-content').css({'margin-top':56});
    //$('.logo-r, .logo-s').css({'top':(hCookie+34)});
    $('.menu-v2 > ul .scroll, .offscreen-menu ul .scroll').css({'top':(hCookie+117)});
    $('.menu-v2.small > ul .scroll').css({'top':(hCookie+85)});
  } else {
    $('.main-content-fluid, .main-content').removeAttr("style");
  }

  if ($('.product-v2.v2024 .product-infos').height() > lastHeight) $('.product-v2.v2024 .product-infos').css({'position': 'sticky', 'top': -($('.product-v2.v2024 .product-infos').height() - lastHeight + 20) + 'px'});
  else $('.product-v2.v2024 .product-infos').css({'position': 'static'});

  var scrollDiff = ($('.product-v2.v2024 .product-infos').height() - lastHeight);
  if (scrollDiff < 0) $('.product-v2.v2024 .product-infos').css({'position': 'sticky', 'top': 100 + 'px'});
  else if ((scrollDiff + currentScrollTop) > 0) $('.product-v2.v2024 .product-infos').css({'position': 'sticky', 'top': -($('.product-v2.v2024 .product-infos').height() - lastHeight + 20) + 'px'});
  else $('.product-v2.v2024 .product-infos').css({'position': 'static'});

  //$('.product-colors-container .product-colors').css({'min-height': $('.product-colors-container .product-colors .link:eq(0)').height()});

  var nbLine = Math.ceil($('.product-colors-container .product-colors .link').length / 5);
  var h = $('.product-colors-container .product-colors .link:eq(0)').height();
  if ($('.product-colors-container').is('.open')) {
    $('.product-colors-container .product-colors').css({'height': ((nbLine * h) + nbLine)});
  } else {
    $('.product-colors-container .product-colors').css({'height':h});
  }
}
function ResizeProductColRight() {
	/*var hColRight = $(".product-v2 .product-infos-col .product-infos").height();
	if (hColRight > (lastHeight - 33)) $(".product-v2 .product-infos-col .product-infos").css({'top': 'calc(100% - ' + (hColRight - ($("body.cookie-open").length > 0 ? 30 : 0)) + 'px - 40px)'});
  	else $(".product-v2 .product-infos-col .product-infos").css({'top': -13});*/
}

function InitScroll() {
    $(window).scroll(function(e){
        currentScrollTop = $(this).scrollTop();

        if (currentScrollTop > lastScrollTop) $(".fixed-menu, .currency_switch").removeClass("scroll-up");
		else $(".fixed-menu, .currency_switch").addClass("scroll-up");

        var oldMenuV2style = ($(".menu-v2").is('.small') ? 'small' : '');
      	if (currentScrollTop > 150) {
        	$(".menu-v2").addClass("small");
          	newMenuV2style = 'small';
        } else {
          	$(".menu-v2").removeClass("small");
          	newMenuV2style = '';
        }
      	if (oldMenuV2style != newMenuV2style) {
          	oldMenuV2style = newMenuV2style;
          	Resize();
      	}

        if (currentScrollTop > lastScrollTop) {
			if ((currentScrollTop - lastScrollTop) > 7) {
				$(".menu-v2, .menu-v2-burger").addClass("scroll-down");
			}
		} else {
			if ((currentScrollTop - lastScrollTop) < -7) {
				$(".menu-v2, .menu-v2-burger").removeClass("scroll-down");
			}
		}

        if (currentScrollTop < 50) {
			$(".menu-v2, .menu-v2-burger").removeClass("scroll-down");
		}

        lastScrollTop = currentScrollTop;

      	// Dropdown
		$(".menu-v2 ul li.dropdown.open").removeClass("open");
      
      	// Product V2
        if ($("#AddToCart-fixed").length > 0){
          /*if (currentScrollTop > ($(".product-v2 .col-right").height() + 85 - 66)) $("#AddToCart-fixed").addClass("hidden");
          else if (lastWidth >= 1100 && currentScrollTop > ($(".product-infos .cta:eq(0)").offset().top - 85 - 33)) $("#AddToCart-fixed").removeClass("hidden");
          else if (lastWidth < 1100 && currentScrollTop > ($(".product-infos .cta:eq(0)").offset().top) - 33) $("#AddToCart-fixed").removeClass("hidden");*/
          /*else if ($("#AddToCart.bold_clone").length > 0 && lastWidth >= 1100 && currentScrollTop > ($(".product-infos .cta:eq(0)").offset().top - 85)) $("#AddToCart-fixed").removeClass("hidden");
          else if ($("#AddToCart.bold_clone").length > 0 && lastWidth < 1100 && currentScrollTop > ($(".product-infos .cta:eq(0)").offset().top)) $("#AddToCart-fixed").removeClass("hidden");
          else if ($(".bis-klaviyo-original").length > 0 && lastWidth >= 1100 && currentScrollTop > ($(".product-infos .cta:eq(0)").offset().top - 85)) $("#AddToCart-fixed").removeClass("hidden");
          else if ($(".bis-klaviyo-original").length > 0 && lastWidth < 1100 && currentScrollTop > ($(".product-infos .cta:eq(0)").offset().top)) $("#AddToCart-fixed").removeClass("hidden");*/
          /*else $("#AddToCart-fixed").addClass("hidden");*/

          if (($("#AddToCart").offset().top - currentScrollTop - lastHeight) > 54) $("#AddToCart-fixed").removeClass("hidden");
          else $("#AddToCart-fixed").addClass("hidden");
        }
      
      	// NEWSLETTER
        if (!callNewsletterDone) {
          if (currentScrollTop > ($('body').height()/1.5) && $('body').height() > (lastHeight * 2)) {
            callNewsletterDone = true;
            testNewsletterCookie = readCookie('rsvp-newsletter-view');
            testNewsletterSubscribeCookie = readCookie('rsvp-newsletter-subscribe');
            if (testNewsletterCookie == undefined && testNewsletterSubscribeCookie == undefined) {
              createCookie('rsvp-newsletter-view', 1, 30); // 1 month
              $('body').addClass('js-newsletter-v2-in');
              Resize();
            }
          }
        }
      
      	// Hands
      	var handsRange = 4;
	    $('.home-2020 .hand').each(function(i){
          if (currentScrollTop > ($(this).data("start-pos") - lastHeight) && currentScrollTop < ($(this).data("start-pos") + (lastHeight * 1))) {
            var decalY = ($(this).data("start-pos") - currentScrollTop) / handsRange;
            
            var scale = 1;
            if (lastWidth <= 768) scale = .75;
            
            var sTransform = 'scale(' + scale + ') translate3d(0, ' + decalY + 'px, 0)';

            $(this).css({
              '-webkit-transform': sTransform,
              '-moz-transform': sTransform,
              '-ms-transform': sTransform,
              '-o-transform': sTransform,
              'transform': sTransform
            });
          }
    	});
      
        // Product 03/2021
		if (currentScrollTop > 100) $("body").addClass("mobile-header-small");
		else $("body").removeClass("mobile-header-small");

        var scrollDiff = ($('.product-v2.v2024 .product-infos').height() - lastHeight);
        if (scrollDiff < 0) $('.product-v2.v2024 .product-infos').css({'position': 'sticky', 'top': 100 + 'px'});
        else if ((scrollDiff + currentScrollTop) > 0) $('.product-v2.v2024 .product-infos').css({'position': 'sticky', 'top': -($('.product-v2.v2024 .product-infos').height() - lastHeight + 20) + 'px'});
        else $('.product-v2.v2024 .product-infos').css({'position': 'static'});
    });
}

function ZoomScrollTo(index, speed) {
  var img = $(".product-medias-col .js-media-zoom .gallery-cell[data-index=" + index + "]");
  //$('html, body').animate({scrollTop: (img.height() * (index - 1))}, speed);
  $('html, body').animate({scrollTop: (img.offset().top + ((img.height() - lastHeight) / 1.2))}, speed);
}

// MOBILE
(function(a){(jQuery.browser=jQuery.browser||{}).mobile=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))})(navigator.userAgent||navigator.vendor||window.opera);

// TOUCH
function isTouchDevice(){return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));}

// COOKIE
function createCookie(a,b,c){var d="";if(c){var e=new Date;e.setTime(e.getTime()+24*c*60*60*1e3),d="; expires="+e.toGMTString()}document.cookie=a+"="+b+d+"; path=/"}function readCookie(a){for(var b,c=a+"=",d=document.cookie.split(";"),e=0;e<d.length;e++){for(b=d[e];" "==b.charAt(0);)b=b.substring(1,b.length);if(0==b.indexOf(c))return b.substring(c.length,b.length)}return null}function eraseCookie(a){createCookie(a,"",-1)}

// DEBUG SCROLLING 2024
var tapArea = document.querySelectorAll('.js-media-zoom');
var startX = 0;
for (var item of tapArea) {
    item.ontouchstart = function(e) {
        startX = e.touches[0].clientX;
    };
    item.ontouchmove = function(e) {
        if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
            e.preventDefault();
        }
    };
}

/* COLLECTION 2025 */
const collectionDescriptionText = document.querySelector('.template-collection-product-v2 .description .text');
if (collectionDescriptionText) {
  const collectionDescriptionMore = document.querySelector('.template-collection-product-v2 .description .toggle-btn.more');
  const collectionDescriptionLess = document.querySelector('.template-collection-product-v2 .description .toggle-btn.less');

  function collectionDescriptionCheckOverflow() {
    collectionDescriptionText.classList.remove('expanded');

    const isOverflowing = collectionDescriptionText.scrollHeight > collectionDescriptionText.clientHeight + 2;

    if (isOverflowing) {
      collectionDescriptionMore.style.display = 'inline';
    } else {
      collectionDescriptionMore.style.display = 'none';
      collectionDescriptionLess.style.display = 'none';
    }
  }

  collectionDescriptionMore.onclick = () => {
    collectionDescriptionText.classList.add('expanded');
    collectionDescriptionMore.style.display = 'none';
    collectionDescriptionLess.style.display = 'inline';
  };

  collectionDescriptionLess.onclick = () => {
    collectionDescriptionText.classList.remove('expanded');
    collectionDescriptionLess.style.display = 'none';
    collectionDescriptionMore.style.display = 'inline';
    collectionDescriptionCheckOverflow();
  };

  collectionDescriptionCheckOverflow();

  window.addEventListener('resize', collectionDescriptionCheckOverflow);
}

/* SCROLLING */
const shortcuts = document.querySelector('.shortcuts');

if (shortcuts) {
  let shortcutsIsDown = false;
  let shortcutsStartX;
  let shortcutsDcrollLeft;

  shortcuts.addEventListener('mousedown', (e) => {
    shortcutsIsDown = true;
    shortcutsStartX = e.pageX - shortcuts.offsetLeft;
    shortcutsDcrollLeft = shortcuts.scrollLeft;
  });
  shortcuts.addEventListener('mouseleave', () => {
    shortcutsIsDown = false;
  });
  shortcuts.addEventListener('mouseup', () => {
    shortcutsIsDown = false;
  });
  shortcuts.addEventListener('mousemove', (e) => {
    if (!shortcutsIsDown) return;
    e.preventDefault();
    const x = e.pageX - shortcuts.offsetLeft;
    const walk = (x - shortcutsStartX) * 1;
    shortcuts.scrollLeft = shortcutsDcrollLeft - walk;
  });
  shortcuts.addEventListener('touchstart', (e) => {
    shortcutsIsDown = true;
    shortcutsStartX = e.touches[0].pageX - shortcuts.offsetLeft;
    shortcutsDcrollLeft = shortcuts.scrollLeft;
  });
  shortcuts.addEventListener('touchend', () => {
    shortcutsIsDown = false;
  });
  shortcuts.addEventListener('touchmove', (e) => {
    if (!shortcutsIsDown) return;
    const x = e.touches[0].pageX - shortcuts.offsetLeft;
    const walk = (x - shortcutsStartX) * 1;
    shortcuts.scrollLeft = shortcutsDcrollLeft - walk;
  });
}